import React, { useState } from "react";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebaseConfig"; // Updated import path
import AuthImage from "../images/auth-image.png";
import { Button } from "../partials/actions/Button";
import { useToast } from "../components/CustomToast";
import logo from "../images/landingPage/logo.svg";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [messageSent, setMessageSent] = useState(false);
  const [error, setError] = useState("");

  const { addToast } = useToast();

  const handleResetPassword = async (e) => {
    e.preventDefault();

    try {
      await sendPasswordResetEmail(auth, email);
      setMessageSent(true);
      addToast("Password reset link has been sent to your email.", "success");
      setError(""); // Clear any previous errors
    } catch (error) {
      setError(error.message);
      setMessageSent(false); // Corrected from setMessage("")
      addToast(error.message, "error");
    }
  };

  return (
    <main className="bg-white dark:bg-gray-900">
      <div className="relative md:flex">
        {/* Content */}
        <div className="md:w-1/2">
          <div className="min-h-[100dvh] h-full flex flex-col after:flex-1">
            {/* Header */}
            <div className="flex-1">
              <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
                {/* Logo */}
                <Link className="block" to="/">
                  <img src={logo} alt="Logo" className="h-20 w-auto" />
                </Link>
              </div>
            </div>

            <div className="max-w-sm mx-auto w-full px-4 py-8">
              <h1 className="text-3xl text-gray-800 dark:text-gray-100 font-bold mb-6">
                Nulstil dit kodeord
              </h1>
              {/* Form */}
              <form onSubmit={handleResetPassword}>
                <div className="space-y-4">
                  <div>
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor="email"
                    >
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="email"
                      className="form-input w-full"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {error && <p className="text-red-500 text-sm mt-4">{error}</p>}
                {messageSent && (
                  <p className="text-green-500 text-sm mt-4">
                    Nulstilling af dit kodeord er sendt til din email- husk at tjekke spam filter.
                  </p>
                )}
                <div className="flex justify-end mt-6">
                  <Button
                    type="submit"
                    text="Send link"
                    variant="primary"
                    disabled={messageSent}
                    className={"rounded-md mt-4"}
                  />
                </div>
              </form>

              {/* Sign In Link */}
              <div className="mt-6 text-start">
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Kan du huske dit kodeord?{" "}
                  <Link
                    to="/signin"
                    className="text-violet-500 hover:text-violet-600 font-medium"
                  >
                    Log ind
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Image and Quote */}
        <div className="hidden md:flex md:w-1/2 bg-gray-100 h-screen overflow-auto flex-col justify-between">
          <div className="p-8 text-right text-black">
            <p className="text-lg font-">
              "Someone's sitting in the shade today,<br /> because someone planted a tree a long time ago."
            </p>
            <p className="text-sm mt-2">- Warren Buffett</p>
          </div>
          <div className="relative flex justify-end items-end h-full">
            <img
              className="object-contain w-2/3 h-auto"
              src={AuthImage}
              alt="Authentication"
            />
          </div>
        </div>
      </div>
    </main>
  );
}

export default ResetPassword;